import { useEffect, useRef } from 'react';
import { usarDialogo } from '../lib/dialogo.ts';

/**
 * Confirmação de ação destrutiva.
 *
 * Um diálogo de verdade, não um `confirm()` do navegador: o nativo não obedece
 * a marca, não diz o que exatamente será apagado e some no celular.
 *
 * O foco vai para **Cancelar**, nunca para o botão de apagar. Quem aperta Enter
 * por reflexo não deve destruir nada.
 */
export function Confirmar({
  titulo,
  descricao,
  rotuloAcao = 'Apagar',
  tom,
  aoConfirmar,
  aoFechar,
}: {
  titulo: string;
  descricao: string;
  rotuloAcao?: string;
  /** `primario`: o sim não destrói nada (aceitar uma proposta, 18/09/2026) — o botão não vai em vermelho. */
  tom?: 'primario';
  aoConfirmar: () => void;
  aoFechar: () => void;
}) {
  const cancelar = useRef<HTMLButtonElement>(null);

  usarDialogo(aoFechar);

  useEffect(() => {
    cancelar.current?.focus();
  }, []);

  return (
    <div
      className="cortina"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) aoFechar();
      }}
    >
      <div className="dialogo dialogo-estreito" role="alertdialog" aria-modal="true">
        <h2 className="titulo-secao">{titulo}</h2>
        <p className="confirmar-texto">{descricao}</p>
        <div className="dialogo-acoes">
          <button type="button" className="botao-secundario" onClick={aoFechar} ref={cancelar}>
            Cancelar
          </button>
          <button
            type="button"
            className={
              // Salvar não é destruir: o vermelho fica para o que não volta.
              tom === 'primario' || rotuloAcao.toLowerCase().startsWith('sim, salvar')
                ? 'botao-primario'
                : 'botao-destrutivo'
            }
            onClick={() => {
              aoConfirmar();
              aoFechar();
            }}
          >
            {rotuloAcao}
          </button>
        </div>
      </div>
    </div>
  );
}
